export const standardizeRedirectText = (text?: string) =>
  text?.endsWith('.') ? text.substring(0, text.length - 1) : text;
